module.exports = __webpack_public_path__ + "img/net-error.53a3e9bd.png";